import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { Row, Field, Label }  from '../../generic'
import TextInput from '../../generic/fields/TextInput'
import styled from 'styled-components'
import icon from '../../../images/icon-event-time.svg'
import moment from 'moment'

const CalendarLink = styled.a`
  // margin-top: 5px;
  display: block;
  img {
    width: 18px;
    height: 18px;
    margin-left: 5px;
    top: 5px;
    position: relative;
  }
`

class When extends Component {
  render() {
    const { userEvent, onChange } = this.props

    let formattedDate = null

    if (userEvent.invitation_date) {
      let date
      if (typeof userEvent.invitation_date === 'string') {
        let dateComponents = userEvent.invitation_date.split("-")
        date = new Date(dateComponents[0], dateComponents[1]-1, dateComponents[2])
      }
      else {
        date = userEvent.invitation_date
      }

      formattedDate = moment(date).format('dddd, MMMM D, YYYY')
    }

    return (
      <Row className="twoCol">
        <img src={icon} width="35" height="41"/>
        <div style={{marginLeft: '20px', flex: 1}}>
      		<h2>Time</h2>
          <p>
            {formattedDate}<br/>
            {userEvent.invitation_start_time}
          </p>
          {this.props.public && (
            <CalendarLink href={process.env.REACT_APP_BASE_URL + "/api/calendar?token=" + this.props.match.params.token}>
              Add to your calendar
              <img src={process.env.REACT_APP_BASE_URL + "/api/calendar-icon.png"} alt="calendar" />
            </CalendarLink>
          )}
        </div>
      </Row>
    )
  }
}

export default withRouter(When)
